import * as OBC from "@thatopen/components";
import Experience from '../Experience';
import * as THREE from 'three';

import * as elementview from "../../ViewModels/elementview.js"
import ElementModelManager from "../../Data/DataManagers/ElementModelManager.js";
import ClashModelManager from "../../Data/DataManagers/ClashModelManager.js";
import ElementModel from "../../Data/ElementModel.js";
import { getMeshColor } from "../IFC/IFCMeshHandler.js";
import { setMeshColor } from "../IFC/IFCMeshHandler.js";
import { setMeshOpacity } from "../IFC/IFCMeshHandler.js";
import Threejsfunctions from "../Threejs/ThreeJSFunctions.js";
import { resetAllMeshVisibility } from "../../ViewModels/clashoverview.js";
import { resetSelectedConstructionUUID } from "../../ViewModels/clashoverview.js";

let manager = new ElementModelManager();
let clashmanager = new ClashModelManager();

let previousHover = null;
let selectedElement = null;
let currentMeshHit = null;
let currentClashHit = null;
let activeHover = null;
let hoverIndex = 0;
let lastMouseEvent = null;

// ✅ Tooltip
function showTooltip(text, x, y) {
    const tooltip = document.getElementById("overlap-tooltip");
    if (!tooltip) return;
    tooltip.innerText = text;
    tooltip.style.display = "block";
    tooltip.style.left = x + 10 + "px";
    tooltip.style.top = y + 10 + "px";
}

function hideTooltip() {
    const tooltip = document.getElementById("overlap-tooltip");
    if (!tooltip) return;
    tooltip.style.display = "none";
}



// ✅ Pointer Move
export function onPointerMove(event) {
    lastMouseEvent = event;
    const experience = new Experience();
    const meshGroup = experience.world.world.scene.three.children[2];
    const clashGroup = experience.world.world.scene.three.children[3];

    if (!meshGroup) return;

    const meshes = experience.getAllMeshesFromObject(meshGroup);
    currentMeshHit = experience.caster.castRay(meshes);

    currentClashHit = null;
    if (clashGroup) {
        const clashes = experience.getAllMeshesFromObject(clashGroup);
        currentClashHit = experience.caster.castRay(clashes);
    }

    if (previousHover && previousHover !== selectedElement) {
        setMeshColor(previousHover, previousHover.oriHex);
        setMeshOpacity(previousHover, 0.5);
    }

    const hoverTargets = [currentMeshHit?.object, currentClashHit?.object].filter(Boolean);
    if (hoverTargets.length === 0) {
        previousHover = null;
        hideTooltip();
        return;
    }

    activeHover = hoverTargets[hoverIndex % hoverTargets.length];
    if (activeHover.oriHex === undefined) {
        activeHover.oriHex = getMeshColor(activeHover).getHex();
    }

    setMeshColor(activeHover, 0xF89335);
    setMeshOpacity(activeHover, 0.5);
    previousHover = activeHover;

    if (hoverTargets.length > 1) {
        showTooltip("Press TAB to switch between overlapping elements.", event.clientX, event.clientY);
    } else {
        hideTooltip();
    }
}

// ✅ Click Handler
export function onClick(event) {
    if (event.target.closest('.ui-element')) return;

    const experience = new Experience();
    const meshGroup = experience.world.world.scene.three.children[2];
    const clashGroup = experience.world.world.scene.three.children[3];

    const meshes = meshGroup ? experience.getAllMeshesFromObject(meshGroup) : [];
    const clashes = clashGroup ? experience.getAllMeshesFromObject(clashGroup) : [];

    const meshHit = experience.caster.castRay(meshes);
    const clashHit = experience.caster.castRay(clashes);

    const clickedObject = [meshHit?.object, clashHit?.object].filter(Boolean)[hoverIndex % ([meshHit, clashHit].filter(Boolean).length)];

    if (clickedObject) {
        handleElementSelect(experience, clickedObject);
    } else {
        if (selectedElement) {

            const panel = document.getElementById("clashOverviewPanel");
            //console.log(panel)
        
            // Toggle panel display
            if (panel.style.display === "block") {
                panel.style.display = "none";
                resetAllMeshVisibility(experience.world.world.scene.three); // Reset visibility on close
                resetSelectedConstructionUUID();

            }
            setMeshColor(selectedElement, selectedElement.oriHex);
            setMeshOpacity(selectedElement, 0.5);

            if (selectedElement.parent.name === experience.constants.clashlistName) {
                elementview.hideOverviewPanel();
            } else {
                elementview.hideOverviewPanel();
            }
            selectedElement = null;
        }
    }
}

export function handleElementSelect(experience, clickedMesh) {
    if (selectedElement && selectedElement !== clickedMesh) {
        setMeshColor(selectedElement, selectedElement.oriHex);
        setMeshOpacity(selectedElement, 0.5);
    }

    selectedElement = clickedMesh;

    if (selectedElement.oriHex === undefined) {
        selectedElement.oriHex = getMeshColor(selectedElement).getHex();
    }

    setMeshColor(selectedElement, 0xF89335);
    setMeshOpacity(selectedElement, 1);

    if (selectedElement.parent.name === experience.constants.clashlistName) {
        elementview.showOverviewPanel(selectedElement.uuid);
    } else {
        const element = manager.getModelByUuid(selectedElement.uuid);
        elementview.showOverviewPanel(element.id);
    }

    //elementview.showOverviewPanel(element.id);

    //Threejsfunctions.centerCameraOnMesh(experience.world.world.camera, selectedElement);

    Threejsfunctions.fitOrthoPerCameraToCenteredObject(experience.world.world.camera, selectedElement);
}



export function handleElementDeselect(experience) {
            setMeshColor(selectedElement, selectedElement.oriHex);
            setMeshOpacity(selectedElement, 0.5);

            if (selectedElement.parent.name === experience.constants.clashlistName) {
                elementview.hideOverviewPanel();
            } else {
                elementview.hideOverviewPanel();
            }
            selectedElement = null;

    //elementview.showOverviewPanel(element.id);

    //Threejsfunctions.centerCameraOnMesh(experience.world.world.camera, selectedElement);

    //Threejsfunctions.fitOrthoPerCameraToCenteredObject(experience.world.world.camera, selectedElement);
}


// ✅ Tab Switching
window.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
        const total = [currentMeshHit?.object, currentClashHit?.object].filter(Boolean).length;
        if (total > 1) {
            event.preventDefault();
            hoverIndex = (hoverIndex + 1) % total;
            if (lastMouseEvent) onPointerMove.call({ experience: new Experience() }, lastMouseEvent);
        }
    }
});

export default class CustomHighlighter {
    constructor() {
        window.addEventListener("pointermove", onPointerMove);
        window.addEventListener("dblclick", onClick);
    }
}



export function findElementById() {
    const inputField = document.getElementById("elementIdInput");
    const elementId = inputField.value.trim();

    

    console.log(elementId)

    if (!elementId) {
        alert("Please enter a valid Element ID.");
        return;
    }

    getElementById(elementId)


    



}


export function getElementById(elementId)
{

    console.log("get element id", elementId);

    const experience = new Experience();

    let element;
    element = manager.getModelById(elementId) ||manager.getModelByUuid(elementId) || clashmanager.getModelByUuid(elementId)
    if(element.mesh)
    {

        //console.log(element.mesh)
        handleElementSelect(experience, element.mesh)

    }

}











